import { useMemo } from 'react';
import { useModuleConfig } from './queries/admin/useModuleConfig';
import type { IemModuleConfig } from '../types/moduleConfig';

/** Shape of the notification terminology label bag. */
export interface NotificationLabels {
  changeTypeLabel: string;
  changeNounLabel: string;
  unknownKitFallback: string;
  summaryPhrase: string;
  ieKitChangesLabel: string;
}

const FALLBACK: NotificationLabels = {
  changeTypeLabel: 'Kit Changes',
  changeNounLabel: 'Kit',
  unknownKitFallback: 'Unknown Kit',
  summaryPhrase: 'kit changes',
  ieKitChangesLabel: 'IE Kit Changes',
};

/**
 * Provides the configurable notification terminology labels from module
 * configuration (e.g. USASOC's "BOI Changes").
 */
export function useNotificationLabels(): NotificationLabels {
  const { config } = useModuleConfig<IemModuleConfig>('iem');
  const notifications = config.features.notifications;

  return useMemo<NotificationLabels>(
    () => ({
      changeTypeLabel: notifications?.change_type_label || FALLBACK.changeTypeLabel,
      changeNounLabel: notifications?.change_noun_label || FALLBACK.changeNounLabel,
      unknownKitFallback: notifications?.unknown_kit_fallback || FALLBACK.unknownKitFallback,
      summaryPhrase: notifications?.summary_phrase || FALLBACK.summaryPhrase,
      ieKitChangesLabel: notifications?.ie_kit_changes_label || FALLBACK.ieKitChangesLabel,
    }),
    [notifications],
  );
}
